import Pqp from "../3x1010/Pqp.js";
import Sounder from "./Tools/sounder/Sounder";
import MainLoop from "./Tools/MainLoop";
import Spran from "./Tools/spran/Spran";
import Controls from "./Tools/controls/Controls";
import Game from "./Game.js";
import Main from "./Main.js";

export default class ScreenStage {
  constructor(data, callback) {
    this.data = data;
    this.deaths = 0;
    this.distance = 0;
    this.angry = false;
    this.callback = callback;
    let tmp = Main.getThemeOnSavegame(this.data.id);
    tmp.played++;
    this.distance = tmp.distance;
    Main.updateSavegame();


  }

  init() {
    this.game = new Game(this.data.id, this.deaths, this.distance, this.angry,this.gameEventsHandler.bind(this));
    this.game.init();

    let tmp = Main.getThemeOnSavegame(this.data.id);
    tmp.run++;
    Main.updateSavegame();

    let o = this.data;
  }



  destroy() {
    this.game.destroy();
  }

  gameEventsHandler(e) {
    if ((e.type === Game.EVENT_DEAD) || (e.type === Game.EVENT_GIVEUP)) {
      let distance = this.game.distance;
      let spears = this.game.spears;
      this.angry = true;
      if (distance > this.distance) {
        this.distance = distance;
      }

      let tmp = Main.getThemeOnSavegame(this.data.id);
      tmp.deaths++;
      if (distance > tmp.distance) {
        tmp.distance = distance;
      }
      tmp.spears += spears;
      Main.updateSavegame();
      

      if (e.type !== Game.EVENT_GIVEUP) {
        this.deaths++;
        this.destroy();
        this.init();
      } else {
        this.destroy();
        this.dispatch({ type: ScreenStage.EVENT_GIVEUP, data: this.data });
      }
    }

    if (e.type === Game.EVENT_WON) {
      let tmp = Main.getThemeOnSavegame(this.data.id);
      tmp.distance = 100;
      tmp.won++;
      Main.updateSavegame();
      this.dispatch({ type: ScreenStage.EVENT_GAME_COMPLETED,data:this.data });
    }



  }

  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }


}

ScreenStage.EVENT_GAME_COMPLETED = "eventGameCompleted"
ScreenStage.EVENT_GIVEUP = "eventGiveUp"
